module.exports = __webpack_public_path__ + "static/media/statistics-kn.473b6d05.svg";